export default function pageLoading() {
  return (
    <div className="flex justify-center items-center h-screen w-screen gap-5">
      <div className="h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballOne" />
      <div className="h-6 w-6  opacity-80 rounded-full bg-jackOrange animate-oscillate ballTwo" />
      <div className="h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballThree" />
    </div>
  );
}
